import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/arithmeticmachine.pdf'; /*Change pdf*/
import { Helmet } from 'react-helmet';

function Page() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {       /*Change left hand panel content*/
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
<var>S&#228;mtliche schriften und briefe series III volume 1</var><br />
        Deutsche Akademie der Wissenschaften (ed)<br />
        p 180<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: unknown<br /><br />
        Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (84k)</Link>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Royal Academy of Sciences Report on Leibniz's Arithmetic Machine</title> {/*Change title*/}
            <meta name="description" content="An English translation of ROYAL ACADEMY OF SCIENCES REPORT ON LEIBNIZ'S ARITHMETIC MACHINE, from January 1675" /> {/*Change meta description*/}
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <h2 id='top' className={`PageTitle ${isMobile ? 'mobile' : ''}`}>ROYAL ACADEMY OF SCIENCES REPORT ON LEIBNIZ'S ARITHMETIC MACHINE</h2> {/*Change title*/}
                  {isMobile ? (
                    <>
                    {renderLinks()}  
                    </>
                  ) : (
                    <>
                    
                    </>
                  )}
                 <br /> {/*Change page content*/}
                 [<b>A III 1, 180</b>]<br /><br />
                
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The same day Mr. Leibniz showed his numerical machine, for performing the 4 rules of arithmetic with great ease, the description of which he will give to put in the Register. Mr. Leibniz will make his estimate and take care to send for the workman. We will make a deal with him, and we will pay him, provided the machine works.
                <br /><br /><br />
                  &#169; Lloyd Strickland 2022
                <br></br><br></br>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default Page;
